<!--
 * @description: Don't description
 * @Author: Mustafa.Yin
 * @Date: 2023-08-29 19:38:12
 * @FilePath: \smart-reco-xnd:\vue_project\smart-reco-portal\src\App.vue
 * @LastEditTime: 2025-08-24 18:38:59
-->
<template>
  <router-view/>
</template>
<script>
import { initUserSessionId } from '@/utils/sessionManager';
export default {
  created() {
    initUserSessionId();
    // 禁止页面缩放
    window.onload = function () {
      document.addEventListener("touchstart", function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener("gesturestart", function (event) {
        event.preventDefault();
      });
    };
  },
}
</script>
<style>
body{
}
</style>
